import { PRELOAD_DATA_LOCAL_STORAGE_KEY } from 'constant/common'
import { getMetadataJSONWithUrlWithCache } from 'utils/id-util/update-util'

const normalizeHostname = (value: string): string | null => {
  try {
    return new URL(value.includes('://') ? value : `https://${value}`).hostname.toLowerCase()
  } catch (err) {
    return null
  }
}

export const isEntryHostOutdated = (currentHost: string, entries: unknown): boolean => {
  const currentHostname = normalizeHostname(currentHost)
  if (!currentHostname || !Array.isArray(entries)) return false

  const entryHostnames = entries
    .map((entry) => (typeof entry === 'string' ? normalizeHostname(entry) : null))
    .filter((hostname): hostname is string => hostname != null)

  if (entryHostnames.length === 0) return false

  return !entryHostnames.includes(currentHostname)
}

export const isCurrentEntryHostOutdated = async (
  preloadPath = process.env.REACT_APP_PRELOAD_PATH as string,
  currentHost = window.location.host
): Promise<boolean> => {
  if (!preloadPath) return false

  const config = await getMetadataJSONWithUrlWithCache(preloadPath, PRELOAD_DATA_LOCAL_STORAGE_KEY)

  return isEntryHostOutdated(currentHost, config?.entries)
}
